import React, { useEffect, useState } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS, GMB_TOPICS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import { TextInput } from "ui/ecosystems/forms/inputs";

const PostTopicTitle = ({
  topicType,
  post,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  className = "",
  errors,
}) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (post.gmbEvent?.title) {
      setValue(post.gmbEvent.title);
    }
  }, []);
  const forTopics = [GMB_TOPICS.OFFER.VALUE, GMB_TOPICS.EVENT.VALUE];
  if (!forTopics.includes(topicType)) {
    return "";
  }

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          {topicType === GMB_TOPICS.OFFER.VALUE ? "Offer" : "Event"} title
          (required)
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.GMB_TOPIC_TYPE}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <p className="small">
        This will lead the post with the caption ('event details') you enter
        above shown below the title.
      </p>
      <TextInput
        value={value}
        onChange={(value) => {
          const newVal = value;
          setValue(newVal);
          if (newVal !== post.gmbEvent?.title) {
            onChange({ [FIELDS.GMB_TITLE]: newVal });
          }
        }}
        disabled={disabled}
      />
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.GMB_TITLE]}
        errors={errors}
      />
    </div>
  );
};

export default PostTopicTitle;
